import {
  IPaginationSet,
  ResponseModel,
  IBlackListModel,
  IPhishFinderModel,
  IEmailSentModel
} from "@/models";
import VetQuestApi from "../VetQuestApi";

export abstract class BlackListService {
  static BASE_URL: string = "admin/blacklist";
  static async GetPhishFinder(
    days: number,
    showBlacklistOnly: boolean = false
  ): Promise<ResponseModel<Array<IPhishFinderModel>>> {
    let response = new ResponseModel<Array<IPhishFinderModel>>(
      0,
      [] as Array<IPhishFinderModel>
    );
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE_URL}/phishfinder?days=${days}&showBlacklistOnly=${showBlacklistOnly}`
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<Array<IPhishFinderModel>>(
        error.response.status,
        [] as Array<IPhishFinderModel>,
        error.response
      );
      return response;
    }
  }

  static async GetUserComment(
    email: string
  ): Promise<ResponseModel<Array<IEmailSentModel>>> {
    let response = new ResponseModel<Array<IEmailSentModel>>(
      0,
      {} as Array<IEmailSentModel>
    );
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE_URL}/comments/${email}`
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<Array<IEmailSentModel>>(
        error.response.status,
        {} as Array<IEmailSentModel>,
        error.response
      );
      return response;
    }
  }

  static async Add(email: string): Promise<ResponseModel<IBlackListModel>> {
    let response = new ResponseModel<IBlackListModel>(0, {} as IBlackListModel);
    try {
      const { data, status } = await VetQuestApi().post(`${this.BASE_URL}`, {
        email
      });
      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IBlackListModel>(
        error.response.status,
        {} as IBlackListModel,
        error.response
      );
      return response;
    }
  }

  static async Delete(email: string): Promise<ResponseModel<IBlackListModel>> {
    let response = new ResponseModel<IBlackListModel>(0, {} as IBlackListModel);
    try {
      const { data, status } = await VetQuestApi().delete(
        `${this.BASE_URL}/${email}`
      );
      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IBlackListModel>(
        error.response.status,
        {} as IBlackListModel,
        error.response
      );
      return response;
    }
  }

  static async AddMultiple(
    emails: string[]
  ): Promise<ResponseModel<Array<IBlackListModel>>> {
    let response = new ResponseModel<Array<IBlackListModel>>(
      0,
      {} as Array<IBlackListModel>
    );
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/AddMultiple`,
        emails
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<Array<IBlackListModel>>(
        error.response.status,
        {} as Array<IBlackListModel>,
        error.response
      );
      return response;
    }
  }
}
